// FAQ content shown on the home page (and marked up as FAQPage structured data).
export const HOME_FAQ: { q: string; a: string }[] = [
  {
    q: 'What does Zemantics do?',
    a: 'Zemantics builds AI agents, agentic orchestrators, data decision pipelines, generative AI and cloud-native software for enterprises, plus the Catalyst Suite of decision-support products.',
  },
  {
    q: 'What are agentic orchestrators?',
    a: 'Software that plans work, delegates it to specialist AI agents, coordinates tools and data, and recovers from failures across multi-step business processes.',
  },
  {
    q: 'Which industries do you serve?',
    a: 'Finance and accounting, healthcare, pharmaceutical and education, with experience in telecom, insurance and FMCG.',
  },
  {
    q: 'How does an engagement start?',
    a: 'With a focused pilot on one process or data set, agreed inputs and a clear review step. Once the value is proven, we harden the solution and expand it.',
  },
];
